import { Component } from "@angular/core";

import { Observable } from "rxjs";

import { IFormGroup } from "@dffedb/forms";
import { DffInfoDialog } from "@dffedb/ui";

import { KontaktoplysningerPopupRef } from "../kontaktoplysninger-popup-ref";
import { KontaktoplysningerPopupContentModel } from "./kontaktoplysninger-popup-content.model";
import { KontaktoplysningerPopupContentSandbox } from "./kontaktoplysninger-popup-content.sandbox";
import { KontaktoplysningerPopupContentViewModel } from "./kontaktoplysninger-popup-content.view-model";

@Component({
    selector: "kontaktoplysninger-popup-content",
    templateUrl: "./kontaktoplysninger-popup-content.component.html",
    styleUrls: ["./kontaktoplysninger-popup-content.component.scss"]
})
export class KontaktoplysningerPopupContentComponent {
    public vm$: Observable<KontaktoplysningerPopupContentViewModel>;

    constructor(
        private readonly popupRef: KontaktoplysningerPopupRef,
        private readonly sandbox: KontaktoplysningerPopupContentSandbox,
        private readonly dialog: DffInfoDialog
    ) {
        this.vm$ = this.sandbox.hentViewModel();
    }

    public onLuk(): void {
        this.popupRef.cancel();
    }

    public async onGem(formGroup: IFormGroup<KontaktoplysningerPopupContentModel>): Promise<void> {
        await this.sandbox.gem(formGroup.value);
        this.popupRef.close();
        await this.dialog.success("", "Vi har registreret dine oplysninger").toPromise();
    }
}
